/* FAQ accordion — one open at a time.

   This is the ONLY job. Opening and closing is <details>' own behaviour and
   is deliberately left alone, so with this file absent the accordion still
   works, just with more than one row open. Everything here is additive.

   Delegated from the [data-rb-faq] wrapper rather than bound per <details>,
   so a section re-render in the customizer needs no re-binding and there is
   nothing to clean up.

   The `toggle` event does not bubble — it is dispatched on the <details>
   itself. Listening in the CAPTURE phase is what lets one wrapper-level
   listener see it. This is the reason a naive bubbling listener here does
   nothing at all.
*/
(() => {
  document.addEventListener(
    'toggle',
    (event) => {
      const item = event.target;
      if (!(item instanceof HTMLDetailsElement) || !item.open) return;

      const group = item.closest('[data-rb-faq]');
      if (!group) return;

      group.querySelectorAll('details[open]').forEach((other) => {
        /* Only direct members of this group — a nested <details> inside an
           answer is its own business, not a sibling to close. */
        if (other !== item && other.closest('[data-rb-faq]') === group) {
          other.open = false;
        }
      });
    },
    true
  );
})();
